import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { AppSettings } from 'src/app/app.settings';
import { FindTimeService } from 'src/app/core/services/find-time.service';
import { Settings } from 'src/app/app.settings.model';
import { PriceListCode } from 'src/app/core/models/price-list-code';
import { AppData } from 'src/app/app.data';



@Component({
  selector: 'app-pricelist-series-row',
  templateUrl: './pricelist-series-row.component.html',
  styleUrls: ['./pricelist-series-row.component.scss']
})
export class PricelistSeriesRowComponent implements OnInit {

  @Input() priceListCode: PriceListCode;
  @Input() odd: string;
  @Input() even: string;
  settings: Settings;
  showDescription = false;
  canChangePrice = false; // only for creating new appointment (not for moving)

  constructor(
    private appSettings: AppSettings,
    private router: Router,
    private appData: AppData,
    private cd: ChangeDetectorRef) {
    this.settings = appSettings.settings;
  }

  ngOnInit() {
    this.canChangePrice = this.appData.appointment == null;
  }


  onSelect(event) {
    this.appData.treatments = null;
    this.appData.priceListCodes = [this.priceListCode];
    this.router.navigate(['/find-time']);
  }

  onChangePrice(event){
    var shouldRefrshDom = false;
    var newPrice = parseFloat(event.target.value) || 0;
    
    if (isNaN(newPrice) || newPrice < 0) {
      newPrice = 0;
      shouldRefrshDom = true;
    }

    this.priceListCode.FinalPrice = newPrice;
    if (this.appData.priceListCodesContains(this.priceListCode.PriceListRefID)) {
      this.appData.priceListCodes = [this.priceListCode]; // when selecting series only one is allowed
    }

    if(shouldRefrshDom){
      // refresh the dom if change was canceled
      this.cd.detectChanges();
    }
  }

}
